import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)

const RouteList = [{
  path: '/home',
  component: resolve => require(['@/views/layout/App.vue'], resolve),
  meta: {
    title: '首页',
    keepAlive: false
  },
  children: [{
    path: '/home',
    name: 'Dashboard',
    meta: {
      title: '首页',
      keepAlive: false
    },
    component: resolve => require(['@/views/home/Index.vue'], resolve)
  },

  // 个人资料
  Personal.index,
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '首页',
      keepAlive: false
    },
    component: resolve => require(['@/views/home/Index.vue'], resolve)
  },

  {
    path: '/merchant',
    name: 'merchant',
    meta: {
      title: '收款商户',
      keepAlive: false
    },
    component: resolve => require(['@/views/merchant/merchant.vue'], resolve)
  },

  {
    path: '/site_apl',
    name: 'siteApl',
    meta: {
      title: '分销商申请',
      keepAlive: false
    },
    component: resolve => require(['@/views/site/site_apl.vue'], resolve)
  }, {
    path: '/pass_site',
    name: 'pass_site',
    meta: {
      title: '分销商申请',
      keepAlive: false
    },
    component: resolve => require(['@/views/site/pass_site.vue'], resolve)
  },
  {
    path: '/site_list',
    name: 'siteList',
    meta: {
      title: '分销商列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/site/site_list.vue'], resolve)
  }, {
    path: '/edit_site',
    name: 'edit_site',
    meta: {
      title: '编辑分销商列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/site/edit_site.vue'], resolve)
  },
  {
    path: '/com-leadingout',
    name: 'com-leadingout',
    meta: {
      title: '分销商数据导出',
      keepAlive: false
    },
    component: resolve => require(['@/views/agent/com-leadingout.vue'], resolve)
  },
  {
    path: '/city_agent',
    name: 'cityAgent',
    meta: {
      title: '城市代理',
      keepAlive: false
    },
    component: resolve => require(['@/views/agent/city_agent.vue'], resolve)
  },
  {
    path: '/site_agent',
    name: 'siteAgent',
    meta: {
      title: '城市代理',
      keepAlive: false
    },
    component: resolve => require(['@/views/agent/site_agent.vue'], resolve)
  },
  {
    path: '/user_list',
    name: 'userList',
    meta: {
      title: '用户列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/agent/user_list.vue'], resolve)
  },
  {
    path: '/goods_order',
    name: 'goodsOrder',
    meta: {
      title: '商品订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/goods_order.vue'], resolve)
  },
  {
    path: '/restaurant_order',
    name: 'restaurantOrder',
    meta: {
      title: '点餐订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/restaurant_order.vue'], resolve)
  },
  {
    path: '/local_order',
    name: 'local_order',
    meta: {
      title: '本地订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/local_order.vue'], resolve)
  },
  {
    path: '/coupons_order',
    name: 'coupons_order',
    meta: {
      title: '券包订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/coupons_order.vue'], resolve)
  },
  {
    path: '/tell_order',
    name: 'tellOrder',
    meta: {
      title: '话费订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/tell_order.vue'], resolve)
  },
  {
    path: '/ds_order',
    name: 'dsGoodsOrder',
    meta: {
      title: '电商订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/ds_order.vue'], resolve)
  },

  {
    path: '/cards_order',
    name: 'cardsOrder',
    meta: {
      title: '结算订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/cards_order.vue'], resolve)
  },
  {
    path: '/user_withdrawal',
    name: 'userWithdrawal',
    meta: {
      title: '用户提现',
      keepAlive: false
    },
    component: resolve => require(['@/views/finance/user_withdrawal.vue'], resolve)
  },
  {
    path: '/site_withdrawal',
    name: 'siteWithdrawal',
    meta: {
      title: '站长提现',
      keepAlive: false
    },
    component: resolve => require(['@/views/finance/site_withdrawal.vue'], resolve)
  },
  {
    path: '/agent_withdrawal',
    name: 'agentWithdrawal',
    meta: {
      title: '代理商提现',
      keepAlive: false
    },
    component: resolve => require(['@/views/finance/agent_withdrawal.vue'], resolve)
  },
  {
    path: '/ticket_list',
    name: 'ticketList',
    meta: {
      title: '卡劵列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/ticket/ticket_list.vue'], resolve)
  },
  {
    path: '/card_types',
    name: 'cardTypes',
    meta: {
      title: '品城卡分类',
      keepAlive: false
    },
    component: resolve => require(['@/views/card/card_types.vue'], resolve)
  },
  {
    path: '/apl_records',
    name: 'aplRecords',
    meta: {
      title: '申请记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/card/apl_records.vue'], resolve)
  },
  {
    path: '/cards',
    name: 'cards',
    meta: {
      title: '品城卡列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/card/cards.vue'], resolve)
  },
  {
    path: '/level',
    name: 'level',
    meta: {
      title: '用户等级列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/level/level.vue'], resolve)
  },
  {
    path: '/price_templete',
    name: 'priceTemplete',
    meta: {
      title: '价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/pricetemplete.vue'], resolve)
  },
  {
    path: '/telPrice',
    name: 'telPrice',
    meta: {
      title: '话费价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/telPrice.vue'], resolve)
  },
  {
    path: '/oilPrice',
    name: 'oilPrice',
    meta: {
      title: '油卡价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/oilPrice.vue'], resolve)
  },
  {
    path: '/restaurant_price',
    name: 'restaurant_price',
    meta: {
      title: '点餐价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/restaurant_price.vue'], resolve)
  },
  {
    path: '/onlinePrice_template',
    name: 'onlinePrice_template',
    meta: {
      title: '商品价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/onlinePrice_template.vue'], resolve)
  },
  {
    path: '/local_price',
    name: 'local_price',
    meta: {
      title: '本地商家价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/local_price.vue'], resolve)
  },
  {
    path: '/local_template_add',
    name: 'local_template_add',
    meta: {
      title: '保存本地商家价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/local_template_add.vue'], resolve)
  },
  {
    path: '/jd_price_edit',
    name: 'jd_price_edit',
    meta: {
        title: '保存京东价格模板',
        keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/coms/jd_price_edit.vue'], resolve),
},
  {
    path: '/poster',
    name: 'poster',
    meta: {
      title: '海报管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/poster/poster.vue'], resolve)
  },
  {
    path: '/menu_function',
    name: 'menu_function',
    meta: {
      title: '菜单功能',
      keepAlive: false
    },
    component: resolve => require(['@/views/poster/menu_function.vue'], resolve)
  },
  {
    path: '/banner',
    name: 'banner',
    meta: {
      title: '首页banner',
      keepAlive: false
    },
    component: resolve => require(['@/views/poster/banner.vue'], resolve)
  },
  {
    path: '/coupon',
    name: 'coupon',
    meta: {
      title: '优惠券管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/coupon.vue'], resolve)
  },
  {
    path: '/couponFf',
    name: 'couponFf',
    meta: {
      title: '优惠券投放',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/coupon_ff.vue'], resolve)
  },
  {
    path: '/couponRecords',
    name: 'couponRecords',
    meta: {
      title: '券码记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/coupon_records.vue'], resolve)
  },

  {
    path: '/goods',
    name: 'goods',
    meta: {
      title: '商品管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/goods.vue'], resolve)
  },
  {
    path: '/firstdiscount',
    name: 'firstdiscount',
    meta: {
      title: '首单特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/firstdiscount.vue'], resolve)
  }, {
    path: '/add_act',
    name: 'add_act',
    meta: {
      title: '新增首单特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/add_act.vue'], resolve)
  },
  {
    path: '/preferentialact',
    name: 'preferentialact',
    meta: {
      title: '影院特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/preferentialact.vue'], resolve)
  }, {
    path: '/add_pre_act',
    name: 'add_pre_act',
    meta: {
      title: '新增影院特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/add_pre_act.vue'], resolve)
  },
  {
    path: '/order_special',
    name: 'order_special',
    meta: {
      title: '点餐特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/order_special.vue'], resolve)
  },
  {
    path: '/order_add',
    name: 'order_add',
    meta: {
      title: '新增点餐特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/order_add.vue'], resolve)
  },
  {
    path: '/local_preferential',
    name: 'local_preferential',
    meta: {
      title: '本地生活特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/local_preferential.vue'], resolve)
  },
  {
    path: '/local_preferential_add',
    name: 'local_preferential_add',
    meta: {
      title: '新增本地生活特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/local_preferential_add.vue'], resolve)
  },
  {
    path: '/act_h5_coupon',
    name: 'act_h5_coupon',
    meta: {
      title: '特惠活动',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/act_h5_coupon.vue'], resolve)
  },
  {
    path: '/red_envelope',
    name: 'red_envelope',
    meta: {
      title: '天降红包',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/red_envelope.vue'], resolve)
  },
  {
    path: '/add_red',
    name: 'add_red',
    meta: {
      title: '新增天降红包',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/add_red.vue'], resolve)
  },
  {
    path: '/act_cinema',
    name: 'act_cinema',
    meta: {
      title: '影院活动',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/act_cinema.vue'], resolve)
  }, {
    path: '/add_cinema_act',
    name: 'add_cinema_act',
    meta: {
      title: '新增影院活动',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/add_cinema_act.vue'], resolve)
  },
  {
    path: '/act_restaurant',
    name: 'act_restaurant',
    meta: {
      title: '点餐领券',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/act_restaurant.vue'], resolve)
  },
  {
    path: '/act_local',
    name: 'act_local',
    meta: {
      title: '本地生活领券',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/act_local.vue'], resolve)
  },
  {
    path: '/act_cinema_bag',
    name: 'act_cinema_bag',
    meta: {
      title: '影院券包',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/act_cinema_bag.vue'], resolve)
  }, {
    path: '/add_cinema_bag_act',
    name: 'add_cinema_bag_act',
    meta: {
      title: '新增影院券包',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/add_cinema_bag_act.vue'], resolve)
  },
  {
    path: '/act_miniapp_coupon',
    name: 'act_miniapp_coupon',
    meta: {
      title: '特惠活动',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/act_miniapp_coupon.vue'], resolve)
  },

  // 价格模板详情
  {
    path: '/template_add',
    name: 'template_add',
    meta: {
      title: '保存价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/template_add.vue'], resolve)
  },

  // 价格模板详情
  {
    path: '/restaurant_template_add',
    name: 'restaurant_template_add',
    meta: {
      title: '保存点餐价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/restaurant_template_add.vue'], resolve)
  },
  // 首页banner
  {
    path: '/home_banner',
    name: 'home_banner',
    meta: {
      title: '首页banner',
      keepAlive: false
    },
    component: resolve => require(['@/views/banner/home_banner.vue'], resolve)
  },
  // 点餐banner
  {
    path: '/mahua_banner',
    name: 'mahua_banner',
    meta: {
      title: '点餐banner',
      keepAlive: false
    },
    component: resolve => require(['@/views/banner/mahua_banner.vue'], resolve)
  },
  //本地banner
  {
    path: '/local_banner',
    name: 'local_banner',
    meta: {
      title: '点餐banner',
      keepAlive: false
    },
    component: resolve => require(['@/views/localBanner/banner.vue'], resolve)
  },
  //推文
  {
    path: '/push',
    name: 'push',
    meta: {
      title: '公众号推文',
      keepAlive: false
    },
    component: resolve => require(['@/views/push/push.vue'], resolve),
  },
  //微博推文
  {
    path: '/microBlog',
    name: 'microBlog',
    meta: {
      title: '微博推文',
      keepAlive: false
    },
    component: resolve => require(['@/views/push/microBlog.vue'], resolve),
  },
  //贴片
  {
    path: '/patch',
    name: 'patch',
    meta: {
      title: '贴片',
      keepAlive: false
    },
    component: resolve => require(['@/views/push/patch.vue'], resolve),
  },
  //主播管理
  {
    path: '/anchorMenu',
    name: 'anchorMenu',
    meta: {
      title: '主播管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/live/anchorMenu.vue'], resolve),
  },
  //主播审核
  {
    path: '/anchor',
    name: 'anchor',
    meta: {
      title: '主播审核',
      keepAlive: false
    },
    component: resolve => require(['@/views/live/anchor.vue'], resolve),
  },
  //商品管理
  {
    path: '/shop',
    name: 'shop',
    meta: {
      title: '商品管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/live/shop.vue'], resolve),
  },
  {
    path: '/seckill',
    name: 'seckill',
    meta: {
      title: '秒杀活动',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/seckill.vue'], resolve)
  },
  {
    path: '/activity_review',
    name: 'activity_review',
    meta: {
      title: '活动审核',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/activity_review.vue'], resolve)
  },
  // 售后工单
  {
    path: '/order_afterSales',
    name: 'order_afterSales',
    meta: {
      title: '售后工单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/order_afterSales.vue'], resolve),
  },
  // 标签管理
  {
    path: '/tags',
    name: 'tags',
    meta: {
      title: '标签管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/tags/tags.vue'], resolve),
  },
  // 秒杀标签
  {
    path: '/allSeckill',
    name: 'allSeckill',
    meta: {
      title: '秒杀标签',
      keepAlive: false
    },
    component: resolve => require(['@/views/tags/allSeckill.vue'], resolve),
  },
  // 电影标签
  {
    path: '/filmTags',
    name: 'filmTags',
    meta: {
      title: '电影标签',
      keepAlive: false
    },
    component: resolve => require(['@/views/tags/filmTags.vue'], resolve),
  },
  // 首页关键词
  {
    path: '/indexKeyword',
    name: 'indexKeyword',
    meta: {
      title: '首页关键词',
      keepAlive: false
    },
    component: resolve => require(['@/views/tags/indexKeyword.vue'], resolve),
  },
  // 美食关键词
  {
    path: '/checkCodeKeyword',
    name: 'checkCodeKeyword',
    meta: {
      title: '美食关键词',
      keepAlive: false
    },
    component: resolve => require(['@/views/tags/checkCodeKeyword.vue'], resolve),
  },
  // 秒杀关键词
  {
    path: '/seckillKeyword',
    name: 'seckillKeyword',
    meta: {
      title: '秒杀关键词',
      keepAlive: false
    },
    component: resolve => require(['@/views/tags/seckillKeyword.vue'], resolve),
  },
  // 商品类目
  {
    path: '/CPSCategory',
    name: 'CPSCategory',
    meta: {
      title: '商品类目',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/CPSCategory.vue'], resolve),
  },
  // CPS商品
  {
    path: '/CPSGoodsList',
    name: 'CPSGoodsList',
    meta: {
      title: 'CPS商品',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/CPSGoods.vue'], resolve),
  },
  // 添加商品
  {
    path: '/addCpsGoods',
    name: 'addCpsGoods',
    meta: {
      title: '添加商品',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/addCpsGoods.vue'], resolve),
  },
  // 视频号商品
  {
    path: '/videoGoods',
    name: 'videoGoods',
    meta: {
      title: '视频号商品',
      keepAlive: false
    },
    component: resolve => require(['@/views/videoGoods/videoGoods.vue'], resolve),
  },
  // 添加视频号商品
  {
    path: '/add_videoGoods',
    name: 'add_videoGoods',
    meta: {
      title: '添加视频号商品',
      keepAlive: false
    },
    component: resolve => require(['@/views/videoGoods/add_videoGoods.vue'], resolve),
  },
  // 视频号商品类目
  {
    path: '/videoCategory',
    name: 'videoCategory',
    meta: {
      title: '添加视频号商品',
      keepAlive: false
    },
    component: resolve => require(['@/views/videoGoods/videoCategory.vue'], resolve),
  },
  // 分享员管理
  {
    path: '/wechatSharer',
    name: 'wechatSharer',
    meta: {
      title: '分享员管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/videoGoods/wechatSharer.vue'], resolve),
  },
  // 分站本地生活价格模版
  {
    path: '/stationt_template',
    name: 'stationt_template',
    meta: {
      title: '分站本地生活价格模版',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/stationt_template.vue'], resolve),
  },
  // 分站本地生活价格模版
  {
    path: '/station_price_edit',
    name: 'station_price_edit',
    meta: {
      title: '分站本地生活价格模版',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/coms/station_price_edit.vue'], resolve),
  },
  // 公司信息
  {
    path: '/Information',
    name: 'Information',
    meta: {
      title: '公司信息',
      keepAlive: false
    },
    component: resolve => require(['@/views/Information/Information.vue'], resolve),
  },
  // 带货申请
  {
    path: '/commerce',
    name: 'commerce',
    meta: {
      title: '带货申请',
      keepAlive: true
    },
    component: resolve => require(['@/views/videoGoods/commerce.vue'], resolve),
  },
  // 带货佣金
  {
    path: '/goodsPrice',
    name: 'goodsPrice',
    meta: {
      title: '带货佣金',
      keepAlive: false
    },
    component: resolve => require(['@/views/videoGoods/goodsPrice.vue'], resolve),
  },
  // 微信群管理
  {
    path: '/crowd_list',
    name: 'crowd_list',
    meta: {
      title: '微信群管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/crowd/crowd_list.vue'], resolve),
  },
  // 视频号主体直播间
  {
    path: '/liveMain',
    name: 'liveMain',
    meta: {
      title: '视频号主体直播间',
      keepAlive: false
    },
    component: resolve => require(['@/views/videoGoods/liveMain.vue'], resolve),
  },
  // 视频号主体直播间
  {
    path: '/videoManagement',
    name: 'videoManagement',
    meta: {
      title: '视频管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/videoGoods/videoManagement.vue'], resolve),
  },
  // 京东商品
  {
    path: '/jd_goods',
    name: 'jd_goods',
    meta: {
      title: '京东商品',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/jd_goods.vue'], resolve),
  },
  // 京东Cookie
  {
    path: '/jd_cookie',
    name: 'jd_cookie',
    meta: {
      title: '京东Cookie',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/jd_cookie.vue'], resolve),
  },
  // 合作管理
  {
    path: '/cooperation',
    name: 'cooperation',
    meta: {
      title: '合作管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/expert/cooperation.vue'], resolve),
  },
  // 达人推广
  {
    path: '/promotion',
    name: 'promotion',
    meta: {
      title: '合作管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/expert/promotion.vue'], resolve),
  },
  // 卡权益包
  {
    path: '/cardWrap',
    name: 'cardWrap',
    meta: {
      title: '卡权益包',
      keepAlive: false
    },
    component: resolve => require(['@/views/card/cardWrap.vue'], resolve),
  },
  // 收款配置
  {
    path: '/payConfig',
    name: 'payConfig',
    meta: {
      title: '收款配置',
      keepAlive: false
    },
    component: resolve => require(['@/views/site/payConfig.vue'], resolve),
  },
  // 优惠劵活动
  {
    path: '/couponActivity',
    name: 'couponActivity',
    meta: {
      title: '优惠劵活动',
      keepAlive: false
    },
    component: resolve => require(['@/views/couponActivity/couponActivity.vue'], resolve),
  },
  // 保存优惠劵
  {
    path: '/add_couponActivity',
    name: 'add_couponActivity',
    meta: {
      title: '保存优惠劵',
      keepAlive: false
    },
    component: resolve => require(['@/views/couponActivity/add_couponActivity.vue'], resolve),
  },
  // 活动任务
  {
    path: '/jhtask',
    name: 'jhtask',
    meta: {
      title: '活动任务',
      keepAlive: false
    },
    component: resolve => require(['@/views/couponActivity/jhtask.vue'], resolve),
  },
  // 新建任务
  {
    path: '/newJhtask',
    name: 'newJhtask',
    meta: {
      title: '新建任务',
      keepAlive: false
    },
    component: resolve => require(['@/views/couponActivity/newJhtask.vue'], resolve),
  },
  // 任务记录
  {
    path: '/taskRecord',
    name: 'taskRecord',
    meta: {
      title: '任务记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/couponActivity/taskRecord.vue'], resolve),
  },
  // 活动记录
  {
    path: '/activityRecord',
    name: 'activityRecord',
    meta: {
      title: '活动记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/couponActivity/activityRecord.vue'], resolve),
  },
   // 活动主题
   {
    path: '/activity_theme',
    name: 'activity_theme',
    meta: {
      title: '活动主题',
      keepAlive: false
    },
    component: resolve => require(['@/views/couponActivity/activity_theme.vue'], resolve),
  },
   // 活动主题
   {
    path: '/add_activity_theme',
    name: 'add_activity_theme',
    meta: {
      title: '活动主题',
      keepAlive: false
    },
    component: resolve => require(['@/views/couponActivity/add_activity_theme.vue'], resolve),
  },
   // 抖音订单
   {
    path: '/dy_order',
    name: 'dy_order',
    meta: {
      title: '抖音订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/dy_order.vue'], resolve),
  },
   // 抖店商品
   {
    path: '/ddGoods',
    name: 'ddGoods',
    meta: {
      title: '抖店商品',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/dd_goods.vue'], resolve),
  },
   // 快手订单
   {
    path: '/ks_order',
    name: 'ks_order',
    meta: {
      title: '快手订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/ks_order.vue'], resolve),
  },
   // 快手价格模板
   {
    path: '/ksPriceTemplate',
    name: 'ksPriceTemplate',
    meta: {
      title: '快手价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/ksPriceTemplate.vue'], resolve),
  },
   // 快手价格模板
   {
    path: '/ksPriceTemplate_add',
    name: 'ksPriceTemplate_add',
    meta: {
      title: '快手价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/ksPriceTemplate_add.vue'], resolve),
  },
   // 美团订单
   {
    path: '/meituan_order',
    name: 'meituan_order',
    meta: {
      title: '美团订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/meituan_order.vue'], resolve),
  },
   // 推客管理
   {
    path: '/twitterUser',
    name: 'twitterUser',
    meta: {
      title: '推客管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/twitterUser.vue'], resolve),
  },
   // 合作店铺
   {
    path: '/tuikeShop',
    name: 'tuikeShop',
    meta: {
      title: '合作店铺',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuikeShop.vue'], resolve),
  },
   // 合作达人
   {
    path: '/tuike_expert',
    name: 'tuike_expert',
    meta: {
      title: '合作达人',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_expert.vue'], resolve),
  },
   // 合作视频
   {
    path: '/tuike_video',
    name: 'tuike_video',
    meta: {
      title: '合作视频',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_video.vue'], resolve),
  },
   // 视频号直播
   {
    path: '/tuike_live',
    name: 'tuike_live',
    meta: {
      title: '视频号直播',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_live.vue'], resolve),
  },
   // 选品广场
   {
    path: '/tuike_product_goods',
    name: 'tuike_product_goods',
    meta: {
      title: '选品广场',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_product_goods.vue'], resolve),
  },
   // 商品分类
   {
    path: '/tuike_goods_class',
    name: 'tuike_goods_class',
    meta: {
      title: '商品分类',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_goods_class.vue'], resolve),
  },
   // 商品管理
   {
    path: '/tuike_goods',
    name: 'tuike_goods',
    meta: {
      title: '商品管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_goods.vue'], resolve),
  },
   // 推客订单
   {
    path: '/tuike_order',
    name: 'tuike_order',
    meta: {
      title: '推客订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_order.vue'], resolve),
  },
   // 商品活动
   {
    path: '/tuike_activity',
    name: 'tuike_activity',
    meta: {
      title: '商品活动',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_activity.vue'], resolve),
  },
   // 标签管理
   {
    path: '/tuike_label',
    name: 'tuike_label',
    meta: {
      title: '标签管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_label.vue'], resolve),
  },
   // 合作联系
   {
    path: '/tuike_contact',
    name: 'tuike_contact',
    meta: {
      title: '合作联系',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_contact.vue'], resolve),
  },
   // 合作
   {
    path: '/tuike_coopera',
    name: 'tuike_coopera',
    meta: {
      title: '合作',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_coopera.vue'], resolve),
  },
   // 数据看板
   {
    path: '/tuike_databoard',
    name: 'tuike_databoard',
    meta: {
      title: '数据看板',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_databoard.vue'], resolve),
  },
   // 机构管理
   {
    path: '/tuike_station_develop',
    name: 'tuike_station_develop',
    meta: {
      title: '机构管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/tuike/tuike_station_develop.vue'], resolve),
  },
    // saas小程序申请
   {
    path: '/saas_app',
    name: 'saas_app',
    meta: {
      title: '小程序申请',
      keepAlive: false
    },
    component: resolve => require(['@/views/saas/saas_app.vue'], resolve),
  },
    // saas小程序支付申请
   {
    path: '/saas_pay',
    name: 'saas_pay',
    meta: {
      title: '小程序支付申请',
      keepAlive: false
    },
    component: resolve => require(['@/views/saas/saas_pay.vue'], resolve),
  },
    // 弹窗
   {
    path: '/popup',
    name: 'popup',
    meta: {
      title: '弹窗',
      keepAlive: false
    },
    component: resolve => require(['@/views/banner/popup.vue'], resolve),
  },
    // 社区运营
   {
    path: '/operation',
    name: 'operation',
    meta: {
      title: '社区运营',
      keepAlive: false
    },
    component: resolve => require(['@/views/banner/operation.vue'], resolve),
  },
    // 洗车价格模板
   {
    path: '/car_price_template',
    name: 'car_price_template',
    meta: {
      title: '洗车价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/car_price_template.vue'], resolve),
  },
    // 洗车价格模板
   {
    path: '/car_price_template_add',
    name: 'car_price_template_add',
    meta: {
      title: '洗车价格模板',
      keepAlive: false
    },
    component: resolve => require(['@/views/pricetemplete/car_price_template_add.vue'], resolve),
  },
  {
    path: '/car_discount',
    name: 'car_discount',
    meta: {
      title: '洗车特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/car_discount.vue'], resolve)
  },
  {
    path: '/car_discount_add',
    name: 'car_discount_add',
    meta: {
      title: '洗车特惠',
      keepAlive: false
    },
    component: resolve => require(['@/views/act/car_discount_add.vue'], resolve)
  },
  {
    path: '/car_order',
    name: 'car_order',
    meta: {
      title: '洗车订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/car_order.vue'], resolve)
  },
   {
    path: '/signed_cinema',
    name: 'signed_cinema',
    meta: {
      title: '签约影院',
    },
    component: resolve => require(['@/views/signed/signed_cinema.vue'], resolve)
  },
   {
    path: '/cinema_film',
    name: 'cinema_film',
    meta: {
      title: '影片',
    },
    component: resolve => require(['@/views/signed/cinema_film.vue'], resolve)
  },
   {
    path: '/cinema_schedule',
    name: 'cinema_schedule',
    meta: {
      title: '排片',
    },
    component: resolve => require(['@/views/signed/cinema_schedule.vue'], resolve)
  },
   {
    path: '/wallet_type',
    name: 'wallet_type',
    meta: {
      title: '礼品卡类型',
    },
    component: resolve => require(['@/views/wallet/wallet_type.vue'], resolve)
  },
   {
    path: '/wallet_list',
    name: 'wallet_list',
    meta: {
      title: '礼品卡',
    },
    component: resolve => require(['@/views/wallet/wallet_list.vue'], resolve)
  },
   {
    path: '/wallet_shelf',
    name: 'wallet_shelf',
    meta: {
      title: '礼品卡批次',
    },
    component: resolve => require(['@/views/wallet/wallet_shelf.vue'], resolve)
  },
   {
    path: '/cake_price',
    name: 'cake_price',
    meta: {
      title: '蛋糕价格模板',
    },
    component: resolve => require(['@/views/pricetemplete/cake_price.vue'], resolve)
  },
   {
    path: '/cake_price_add',
    name: 'cake_price_add',
    meta: {
      title: '蛋糕价格模板',
    },
    component: resolve => require(['@/views/pricetemplete/cake_price_add.vue'], resolve)
  },
   {
    path: '/cake_discount',
    name: 'cake_discount',
    meta: {
      title: '蛋糕特惠',
    },
    component: resolve => require(['@/views/act/cake_discount.vue'], resolve)
  },
   {
    path: '/cake_discount_add',
    name: 'cake_discount_add',
    meta: {
      title: '蛋糕特惠',
    },
    component: resolve => require(['@/views/act/cake_discount_add.vue'], resolve)
  },
   {
    path: '/cake_order',
    name: 'cake_order',
    meta: {
      title: '蛋糕订单',
    },
    component: resolve => require(['@/views/order/cake_order.vue'], resolve)
  },
   {
    path: '/risk_control',
    name: 'risk_control',
    meta: {
      title: '风控规则',
    },
    component: resolve => require(['@/views/order/risk_control.vue'], resolve)
  },
  {
    path: '/yzh_price',
    name: 'yzh_price',
    meta: {
      title: '云中鹤价格模板',
    },
    component: resolve => require(['@/views/pricetemplete/yzh_price.vue'], resolve)
  },
   {
    path: '/yzh_price_add',
    name: 'yzh_price_add',
    meta: {
      title: '云中鹤价格模板',
    },
    component: resolve => require(['@/views/pricetemplete/yzh_price_add.vue'], resolve)
  },
   {
    path: '/yzh_discount',
    name: 'yzh_discount',
    meta: {
      title: '云中鹤特惠',
    },
    component: resolve => require(['@/views/act/yzh_discount.vue'], resolve)
  },
   {
    path: '/yzh_discount_add',
    name: 'yzh_discount_add',
    meta: {
      title: '云中鹤特惠',
    },
    component: resolve => require(['@/views/act/yzh_discount_add.vue'], resolve)
  },
  {
    path: '/yzh_order',
    name: 'yzh_order',
    meta: {
      title: '云中鹤订单',
    },
    component: resolve => require(['@/views/order/yzh_order.vue'], resolve)
  },
  ]
},
{
  path: '/login',
  name: 'Login',
  meta: {
    title: '登录',
    keepAlive: false
  },
  components: {
    blank: resolve => require(['@/views/login/Login.vue'], resolve)
  }
},
{
  path: '/*',
  name: 'NotFound',
  meta: {
    title: '404',
    keepAlive: true
  },
  components: {
    blank: resolve => require(['@/views/error/404.vue'], resolve)
  }
}
]

export default new Router({
  routes: RouteList
})
